<template>
  <div class="partner-form">
    <div class="container">
      <div class="board">
        <h3 class="title">
          Cadastre seu estabelecimento e seja um parceiro Videomedi
        </h3>
        <PartnerForm />
      </div>
    </div>
  </div>
</template>

<script>
import PartnerForm from "@/components/PartnerForm.vue";

export default {
  components: {
    PartnerForm
  }
};
</script>

<style></style>
